import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import {
  Technician,
  TechnicianCreateRequest,
  TechnicianListQuery,
  TechnicianListResult,
  TechnicianUpdateRequest
} from '../models/technician.model';

@Injectable({ providedIn: 'root' })
export class TechnicianService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/technicians`;

  getTechnicians(query: TechnicianListQuery = {}): Observable<TechnicianListResult> {
    let params = new HttpParams();
    if (query.search) params = params.set('search', query.search);
    if (query.page) params = params.set('page', query.page);
    if (query.pageSize) params = params.set('pageSize', query.pageSize);

    return this.http.get<TechnicianListResult>(this.baseUrl, { params });
  }

  getTechnicianById(technicianId: number): Observable<Technician> {
    return this.http.get<Technician>(`${this.baseUrl}/${technicianId}`);
  }

  createTechnician(request: TechnicianCreateRequest): Observable<Technician> {
    return this.http.post<Technician>(this.baseUrl, request);
  }

  updateTechnician(technicianId: number, request: TechnicianUpdateRequest): Observable<Technician> {
    return this.http.put<Technician>(`${this.baseUrl}/${technicianId}`, request);
  }

  deactivateTechnician(technicianId: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${technicianId}`);
  }
}
